// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 17) return "static/js/2f3d1408ac9e1ae814a3.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"84133eb06fc98226c452","124":"6b4ac95995bdc730a386","125":"c74657094e97682ff7d3"}[chunkId] + ".chunk.js";
};